/*! For license information please see f25rt_main.js.LICENSE.txt */ ! function() {
    var e = {
            "./src/js/main.js": function(e, s, t) {
                "use strict";
                t("jquery");
                var i = t("./src/widgets/debug.js"),
                    n = t("jquery");

                function o(e) {
                    return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                    }, o(e)
                }

                function c(e, s, t) {
                    var i;
                    return i = function(e, s) {
                        if ("object" != o(e) || !e) return e;
                        var t = e[Symbol.toPrimitive];
                        if (void 0 !== t) {
                            var i = t.call(e, s || "default");
                            if ("object" != o(i)) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.")
                        }
                        return ("string" === s ? String : Number)(e)
                    }(s, "string"), (s = "symbol" == o(i) ? i : i + "") in e ? Object.defineProperty(e, s, {
                        value: t,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[s] = t, e
                }(0, i.debugfunction)();
                document.documentElement.clientHeight || window.innerHeight;
                var a = document.documentElement.clientWidth || window.innerWidth,
                    r = !1,
                    p = a < 750,
                    g = n(window).scrollTop();
                n(window).on("scroll", (function(e) {
                    var s = n(window).scrollTop();
                    s > g ? "down" : "up", g = s, n(n.CN(".product-container .section")).each((function(e, s) {
                        n(s).data("section")
                    }))
                }));
                var _ = new TimelineLite({
                        paused: !0
                    }),
                    m = {
                        y: 60,
                        opacity: 0
                    },
                    u = {
                        y: 0,
                        opacity: 1,
                        ease: "power2.easeOut"
                    };

                function l() {
                    return n("#play-video-text").width() / n("#play-video-line-box").width() * 100
                }

                function d() {
                    if (ScrollTrigger.create({
                            animation: gsap.timeline().set(n.CN(".section-thirteenth .thirteenth-title span"), {
                                x: "30vw",
                                opacity: 0
                            }).add(gsap.fromTo(n.CN(".section-thirteenth .thirteenth-title span"), 1, {
                                x: "30vw",
                                opacity: 0
                            }, {
                                x: 0,
                                opacity: 1,
                                ease: "power1.out"
                            })),
                            trigger: n.CN(".section-thirteenth .thirteenth-title span"),
                            start: "top top+=30%",
                            end: p ? "top top-=100%" : "top top-=80%",
                            scrub: !0,
                            markers: r,
                            invalidateOnRefresh: !0,
                            id: "s13"
                        }), n(n.CN(".btn-play-video")).length) {
                        n(n.CN(".btn-play-video")).on("click", (function() {
                            var e, s;
                            e = n(this), s = "video", e.parent().find(s).each((function() {
                                var s = n(this).get(0);
                                s && (s.play(), e.css("opacity", 0), setTimeout((function() {
                                    e.css("display", "none")
                                }), 600))
                            }))
                        })), n(n.CN(".s13-listen-video")).each((function() {
                            n(this).on("ended", (function() {
                                console.log("视频播放已完成！");
                                var e, s = n(this).closest(n.CN(".item")).find(n.CN(".btn-play-video"));
                                s && ((e = s).css("display", "block"), setTimeout((function() {
                                    e.css("opacity", 1)
                                }), 100))
                            }))
                        }))
                    }
                }
                n((function() {
                    var e, s, t, i;
                    n(n.CN(".fadein-up")).each((function() {
                            gsap.set(n(this), {
                                opacity: 0,
                                y: 40
                            }), gsap.fromTo(n(this), {
                                y: 40,
                                opacity: 0
                            }, {
                                y: 0,
                                opacity: 1,
                                immediateRender: !0,
                                scrollTrigger: {
                                    trigger: n(this),
                                    start: "top bottom-=" + (p ? "5%" : "15%"),
                                    end: "top+=" + (p ? 100 : 150) + " bottom-=" + (p ? "5%" : "15%"),
                                    markers: r,
                                    invalidateOnRefresh: !0,
                                    scrub: .5
                                }
                            })
                        })), n(n.CN(".container-fadein-up-list")).each((function() {
                            var e = n(this).attr("start") || "30%",
                                s = gsap.timeline({
                                    scrollTrigger: {
                                        trigger: n(this),
                                        start: "top bottom-=" + (p ? "15%" : e),
                                        end: "top+=50px bottom-=" + (p ? "15%" : "10%"),
                                        invalidateOnRefresh: !0,
                                        toggleActions: "play none reverse none"
                                    },
                                    onComplete: function() {
                                        ScrollTrigger.refresh()
                                    }
                                });
                            n(this).find(n.CN(".fadein-up-list")).each((function(e, t) {
                                gsap.set(n(t), {
                                    opacity: 0,
                                    y: 100
                                }), s.fromTo(n(t), {
                                    y: 100,
                                    opacity: 0
                                }, {
                                    y: 0,
                                    opacity: 1,
                                    duration: .5,
                                    ease: "power0.easeOut",
                                    immediateRender: !0
                                }, "<40%")
                            }))
                        })), n("".concat(n.CN(".section-line-wrap .section-line"))).each((function() {
                            gsap.set(n(this), {
                                width: 0
                            }), gsap.fromTo(n(this), {
                                width: 0
                            }, {
                                width: "100%",
                                immediateRender: !0,
                                duration: .5,
                                ease: "power2.easeOut",
                                scrollTrigger: {
                                    trigger: n(this),
                                    start: "top bottom-=" + (p ? "15%" : "30%"),
                                    end: "top+=50px bottom-=" + (p ? "15%" : "40%"),
                                    invalidateOnRefresh: !0,
                                    toggleActions: "play none reverse none"
                                },
                                delay: Number(n(this).attr("delay")) || 0
                            })
                        })), n("".concat(n.CN(".section-title-line-wrap .section-title-line"))).each((function() {
                            gsap.set(n(this), {
                                width: 0
                            }), gsap.fromTo(n(this), {
                                width: 0
                            }, {
                                width: "100%",
                                immediateRender: !0,
                                duration: .5,
                                ease: "power2.easeOut",
                                scrollTrigger: {
                                    trigger: n(this),
                                    start: "top bottom-=" + (p ? "15%" : "30%"),
                                    end: "top+=50px bottom-=" + (p ? "15%" : "40%"),
                                    invalidateOnRefresh: !0,
                                    toggleActions: "play none reverse none"
                                },
                                delay: Number(n(this).attr("delay")) || 0
                            })
                        })),
                        function() {
                            function e(e) {
                                return n(n.CN(".section1" + e))
                            }
                            document.querySelector('.fv_area').classList.add('active');
                            // _.fromTo(e("-title-pc"), .5, m, u), _.fromTo(e("-keyword-pc"), .5, m, u, .1), _.fromTo(e("-btnbox"), .5, m, u, .2), document.getElementById("kv-video-pc").addEventListener("ended", (function() {
                            //     console.log("视频播放已完成！"), _.play()
                            // }))
                        }(), n(n.CN(".section-forth .section-wrap")).on({
                            mouseenter: function() {
                                gsap.to(n.CN(".section-forth .line-box .line-left"), 1, {
                                    width: "80%",
                                    ease: "power3.out"
                                })
                            },
                            mouseleave: function() {
                                gsap.to(n.CN(".section-forth .line-box .line-left"), 1, {
                                    width: l() + "%",
                                    ease: "power3.out"
                                })
                            }
                        }), ScrollTrigger.create({
                            animation: gsap.timeline().add(gsap.fromTo(n.CN(".section-fifth .fifth-title span"), 1, {
                                opacity: 1
                            }, {
                                opacity: .1
                            })),
                            trigger: n.CN(".section-fifth .fifth-title span"),
                            start: p ? "top bottom+=20%" : "top top+=50%",
                            end: p ? "top top+=30" : "top top+1000",
                            scrub: !0,
                            markers: r,
                            invalidateOnRefresh: !0,
                            id: "s5"
                        }), gsap.set(n.CN(".fadein-up6"), {
                            opacity: 0,
                            y: 40
                        }), gsap.fromTo(n.CN(".fadein-up6"), {
                            y: 40,
                            opacity: 0
                        }, {
                            y: 0,
                            opacity: 1,
                            immediateRender: !0,
                            scrollTrigger: {
                                trigger: n.CN(".fadein-up6"),
                                start: "top bottom-=" + (p ? "5%" : "15%"),
                                end: "top+=" + (p ? 100 : 150) + " bottom-=" + (p ? "5%" : "15%"),
                                invalidateOnRefresh: !0,
                                scrub: .5,
                                onEnter: function() {
                                    gsap.fromTo("#sixth-circle", 2, {
                                        strokeDasharray: "0 252"
                                    }, {
                                        strokeDasharray: "252 0",
                                        ease: "power1.out"
                                    }), gsap.fromTo(n.CN(".section-sixth .svg-box1"), 5, {
                                        width: 0
                                    }, {
                                        width: "100%",
                                        ease: "expo.out"
                                    }), n(n.CN(".section-sixth .svg-box2")).removeClass(n.CN("block-ani")), setTimeout((function() {
                                        n(n.CN(".section-sixth .svg-box2")).addClass(n.CN("block-ani"))
                                    }), 50)
                                }
                            }
                        }), e = n.CN(".section-ninth .ninth-video-box"), s = n.CN(".section-ninth .video-box"), t = n.CN(".section-ninth .video-text"), i = gsap.timeline().fromTo(e, {
                            x: "-600vw"
                        }, {
                            x: 0,
                            ease: "power1.linear",
                            duration: 10
                        }).set(e, {
                            borderRadius: 0
                        }).set(t, {
                            y: 0,
                            opacity: 1,
                            borderRadius: 0
                        }).to(e, {
                            height: p ? "25px" : "50px",
                            duration: p ? 4 : 2
                        }).add("heightGap", p ? "+=6" : "+=8").set(s, {
                            opacity: 1
                        }, "heightGap").set(e, {
                            background: "transparent"
                        }).to(e, {
                            height: p ? "168px" : "500px",
                            duration: 10
                        }), ScrollTrigger.create(c(c(c(c(c(c({
                            animation: i,
                            trigger: e,
                            start: "center center"
                        }, "start", "top top+=50%"), "end", "top top-=450%"), "scrub", !0), "markers", r), "invalidateOnRefresh", !0), "id", "line_s9")), gsap.set(n.CN(".fadein-up10"), {
                            opacity: 0,
                            y: 40
                        }), gsap.fromTo(n.CN(".fadein-up10"), {
                            y: 40,
                            opacity: 0
                        }, {
                            y: 0,
                            opacity: 1,
                            immediateRender: !0,
                            scrollTrigger: {
                                trigger: n.CN(".fadein-up10"),
                                start: "top bottom-=" + (p ? "5%" : "15%"),
                                end: "top+=" + (p ? 100 : 150) + " bottom-=" + (p ? "5%" : "15%"),
                                invalidateOnRefresh: !0,
                                scrub: .5,
                                onEnter: function() {
                                    gsap.fromTo("#tenth-line", 2.5, {
                                        strokeDasharray: "0 450"
                                    }, {
                                        strokeDasharray: "450 0",
                                        ease: "expo.out"
                                    })
                                }
                            }
                        }), d(), ScrollTrigger.create({
                            animation: gsap.timeline().add(gsap.fromTo(n.CN(".section-fourteenth .fourteenth-title span"), 1, {
                                x: 0,
                                opacity: 1
                            }, {
                                x: "-30vw",
                                opacity: 0,
                                ease: "power1.out"
                            })),
                            trigger: n.CN(".section-fourteenth .fourteenth-title span"),
                            start: p ? "top top" : "top top-=70%",
                            end: p ? "top top-=100%" : "top top-=200%",
                            scrub: !0,
                            markers: r,
                            invalidateOnRefresh: !0,
                            id: "s14"
                        })
                })), window.onload = function() {
                    n("#play-video-line").css("width", l() + "%")
                }, n(window).on("resize", (function(e) {}))
            },
            "./src/widgets/AlbumCart/index.js": function(e, s, t) {
                "use strict";

                function i() {
                    // document.documentElement.clientWidth || window.innerWidth;
                    // var e = new Swiper("#albumSwiper", {
                    //     loop: !0,
                    //     effect: "cards",
                    //     grabCursor: !0
                    // });
                    // document.querySelector("#albumSwiper").addEventListener("click", (function() {
                    //     e.slideNext()
                    // }))
                }
                t.d(s, {
                    default: function() {
                        return i
                    }
                })
            },
            "./src/widgets/Album/index.js": function(e, s, t) {
                "use strict";

                function i() {
                    // document.documentElement.clientWidth || window.innerWidth;
                    // new Swiper("#qSwiperalbum", {
                    //     grabCursor: !0,
                    //     speed: 2e4,
                    //     loop: !0,
                    //     slidesPerView: "auto",
                    //     a11y: {
                    //         slideRole: "listitem"
                    //     },
                    //     autoplay: {
                    //         pauseOnMouseEnter: !0,
                    //         disableOnInteraction: !1,
                    //         delay: 0
                    //     }
                    // }), new Swiper("#qSwiperalbum-1", {
                    //     grabCursor: !0,
                    //     speed: 16e3,
                    //     loop: !0,
                    //     slidesPerView: "auto",
                    //     a11y: {
                    //         slideRole: "listitem"
                    //     },
                    //     autoplay: {
                    //         pauseOnMouseEnter: !0,
                    //         disableOnInteraction: !1,
                    //         delay: 0
                    //     }
                    // })
                }
                t.d(s, {
                    default: function() {
                        return i
                    }
                })
            },
            "./src/widgets/ClassExtension.js": function(e, s, t) {
                ! function(e) {
                    e.extend({
                        CN: function(e) {
                            return e.startsWith(".") ? e.split(" ").map((function(e) {
                                return e.startsWith(".") ? ".".concat("f25rt_").concat(e.slice(1)) : e
                            })).join(" ") : "f25rt_" + e
                        }
                    })
                }(t("jquery"))
            },
            "./src/widgets/ContrastContainer/index.js": function(e, s, t) {
                "use strict";
                var i = t("jquery");

                function n(e, s) {
                    return function(e) {
                        if (Array.isArray(e)) return e
                    }(e) || function(e, s) {
                        var t = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != t) {
                            var i, n, o, c, a = [],
                                r = !0,
                                p = !1;
                            try {
                                if (o = (t = t.call(e)).next, 0 === s) {
                                    if (Object(t) !== t) return;
                                    r = !1
                                } else
                                    for (; !(r = (i = o.call(t)).done) && (a.push(i.value), a.length !== s); r = !0);
                            } catch (e) {
                                p = !0, n = e
                            } finally {
                                try {
                                    if (!r && null != t.return && (c = t.return(), Object(c) !== c)) return
                                } finally {
                                    if (p) throw n
                                }
                            }
                            return a
                        }
                    }(e, s) || function(e, s) {
                        if (!e) return;
                        if ("string" == typeof e) return o(e, s);
                        var t = Object.prototype.toString.call(e).slice(8, -1);
                        "Object" === t && e.constructor && (t = e.constructor.name);
                        if ("Map" === t || "Set" === t) return Array.from(e);
                        if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return o(e, s)
                    }(e, s) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                    }()
                }

                function o(e, s) {
                    (null == s || s > e.length) && (s = e.length);
                    for (var t = 0, i = new Array(s); t < s; t++) i[t] = e[t];
                    return i
                }
                i((function() {
                    var e = document.documentElement.clientWidth || window.innerWidth;
                    ! function() {
                        if (document.getElementById("compare_data")) {
                            var s, t = JSON.parse(document.getElementById("compare_data").text),
                                o = (s = t, JSON.parse(JSON.stringify(s)));
                            c(t), i(i.CN(".contrast-container")).on("click", i.CN(".h4"), (function() {
                                var e = this;
                                i(i.CN(".contrast-container .h4")).each((function(s, t) {
                                    t !== e && i(t).children(i.CN(".popup")).hide()
                                })), i(this).children(i.CN(".popup")).toggle()
                            })), i(document).on("click", (function(e) {
                                i(e.target).closest(i.CN(".contrast-container .h4")).length || i(i.CN(".contrast-container .popup")).hide()
                            })), i(i.CN(".contrast-container")).on("click", i.CN(".h4 .modlist"), (function(e) {
                                var s = i(this).attr("productname"),
                                    n = i(this).attr("parentlevel");
                                o[n] = t[s], c(o)
                            }))
                        }

                        function c(s) {
                            var o = "";
                            Object.entries(s).forEach((function(s, i) {
                                var c = n(s, 2),
                                    a = c[0],
                                    r = c[1];
                                i > (e > 750 ? 2 : 1) || (o += '<div class="'.concat("f25rt_", 'item">\n          <img src="').concat(r.imgsrc, '" alt="').concat(r.name, '">\n          <div class="').concat("f25rt_", 'h4">').concat(r.name, '\n            <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path d="M1.5 1L6.5 6L11.5 1" stroke="#DB2D30" stroke-width="2" stroke-linecap="round"/>\n            </svg>\n            <div class="').concat("f25rt_", 'popup">\n              <div class="').concat("f25rt_", 'models">').concat(r.choose, "</div>"), Object.entries(t).forEach((function(e) {
                                    var s = n(e, 2),
                                        t = s[0],
                                        i = s[1];
                                    o += '<p class="'.concat("f25rt_", 'modlist" parentlevel="').concat(a, '" productname="').concat(t, '">\n                <svg class="').concat(r.name == i.name ? "".concat("f25rt_", "active") : "", '" width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n                  <path d="M1.33346 3L4.33354 6L10.0002 1" stroke="black" stroke-width="1.5" stroke-linecap="round"/>\n                </svg><span>').concat(i.name, "</span></p>")
                                })), o += "</div>\n          </div>\n          <div>", r.open_purchase ? o += '<button class="'.concat("f25rt_", 'buy-now purchase-sales-channel-btn" product-name="').concat(r.name.replaceAll(" ", "-").replaceAll("Roborock-", ""), '" data-toggle="modal" data-target="#product-sales-channel">').concat(r.btntext, "</button>") : r.show_link_btn ? o += '<a href="'.concat(r.btn_link, '"><button class="').concat("f25rt_", 'buy-now">').concat(r.btntext, "</button></a>") : o += '<div class="'.concat("f25rt_", 'no_btn"></div>'), o += "</div>\n          <ul>", Object.entries(r).forEach((function(e) {
                                    var s = n(e, 2),
                                        t = s[0],
                                        i = s[1];
                                    t.includes("item") && (o += "<li>".concat(i, "</li>"))
                                })), o += "</ul>\n        </div>")
                            })), i("#compare-table").html(o), "function" == typeof ReloadSalesChannelEvents && ReloadSalesChannelEvents()
                        }
                    }()
                }))
            },
            "./src/widgets/FullScreenVideo/index.js": function(e, s, t) {
                "use strict";
                var i = t("jquery");
                i((function() {
                    function e() {
                        i(i.CN(".full_screen_video")).hide();
                        var e = new window.CustomEvent("hide.all.modals");
                        document.dispatchEvent(e)
                    }! function() {
                        var e = document.querySelectorAll(i.CN(".as-youtube-video"));
                        if (e.length > 0) {
                            var s = document.createElement("script");
                            s.src = "https://www.youtube.com/iframe_api";
                            var t = document.getElementsByTagName("script")[0];
                            t.parentNode.insertBefore(s, t);
                            var n = [],
                                o = function(e) {
                                    document.addEventListener("hide.all.modals", (function(e) {
                                        for (var s = 0; s < n.length; s++) n[s].pauseVideo()
                                    }))
                                };
                            window.onYouTubeIframeAPIReady = function() {
                                for (var s = 0; s < e.length; s++) n.push(new window.YT.Player(e[s], {
                                    events: {
                                        onReady: o
                                    }
                                }))
                            }
                        }
                    }(), i(i.CN(".section-forth .video-box")).on("click", (function(e) {
                        // i(i.CN(".full_screen_video")).show()
                        let id = i(i.CN(".section-forth .video-box")).attr('data-id');
                        vnsModal.youtubeOpen(id);
                        return false;
                    })), i(i.CN(".full_screen_video")).on("click", (function(s) {
                        // e()
                    })), i(i.CN(".full_screen_video .video-close")).on("click", (function(s) {
                        // e()
                    }))
                }))
            },
            "./src/widgets/LeftNav/index.js": function(e, s, t) {
                "use strict";
                t("jquery")
            },
            "./src/widgets/SeriseContainer/index.js": function(e, s, t) {
                "use strict";
                var i = t("jquery");
                i((function() {
                    i("#sideBtn").on("click", (function() {
                        var e = i(i.CN(".serise-container"));
                        e.hasClass(i.CN("show")) ? e.addClass(i.CN("hide")).removeClass(i.CN("show")) : e.addClass(i.CN("show")).removeClass(i.CN("hide"))
                    })), i("#popup-tab").delegate(i.CN(".tabTitle"), "click", (function(e) {
                        i(this).addClass(i.CN("active")).siblings().removeClass(i.CN("active")), i(i.CN(".tabbody .tabCard")).eq(i(this).index()).show().siblings().hide(), i(i.CN(".pc .img")).eq(i(this).index()).addClass(i.CN("active")).siblings().removeClass(i.CN("active")), i(i.CN(".mob .img")).eq(i(this).index()).addClass(i.CN("active")).siblings().removeClass(i.CN("active"))
                    }))
                }))
            },
            "./src/widgets/basics.js": function(e, s, t) {
                "use strict";
                t.d(s, {
                    basics: function() {
                        return n
                    }
                });
                var i = t("jquery");

                function n() {
                    i(".ad-bar").length > 0 && i(i.CN(".container")).css({
                        "margin-top": "110px"
                    }), i("#product_subscription_b").on("click", (function() {
                        i("#subscribe-modal").css({
                            display: "block"
                        })
                    }))
                }
            },
            "./src/widgets/debug.js": function(e, s, t) {
                "use strict";
                t.d(s, {
                    debugfunction: function() {
                        return n
                    }
                });
                var i = t("jquery");

                function n() {
                    var e, s, t, n, o, c, a, r, p = null,
                        g = !1;

                    function _() {
                        if (p) {
                            var e = document.documentElement.clientHeight || window.innerHeight,
                                s = document.documentElement.clientWidth || window.innerWidth;
                            p.text("屏幕分辨率: ".concat(s, " x ").concat(e))
                        }
                    }
                    // e = window.location.href, s = new URL(e), t = s.hostname, n = s.searchParams.get("debugResolution"), !(o = /^((25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/).test(t) && !/^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|(([0-9a-fA-F]{1,4}:){1,7}|:):(([0-9a-fA-F]{1,4}:){1,7}|:))$/.test(t) && "show" != n || (g || ((p = i("<div>", {
                    //     id: "resolution-container",
                    //     style: "position:fixed;top:10px;left:10px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);",
                    //     text: "屏幕分辨率: 加载中..."
                    // })).appendTo("body"), g = !0), _(), o.test(t)), i(window).resize((c = _, a = 200, r = 0, function() {
                    //     var e = (new Date).getTime();
                    //     e - r >= a && (r = e, c.apply(void 0, arguments))
                    // }))
                }
            },
            "./src/widgets/index.js": function(e, s, t) {
                "use strict";
                t("./src/widgets/ContrastContainer/index.js"), t("./src/widgets/FullScreenVideo/index.js"), t("./src/widgets/LeftNav/index.js"), t("./src/widgets/SeriseContainer/index.js"), t("./src/widgets/ClassExtension.js");
                var i = t("./src/widgets/Album/index.js"),
                    n = t("./src/widgets/AlbumCart/index.js"),
                    o = t("./src/widgets/basics.js");
                (0, i.default)(), (0, n.default)(), (0, o.basics)()
            },
            "./src/index.html": function(e, s, t) {
                "use strict";
                var i = t("./node_modules/html-loader/dist/runtime/getUrl.js"),
                    n = t.n(i),
                    o = new URL(t("./src/assets/video/section1_KV.mp4"), t.b),
                    c = new URL(t("./src/assets/video/section1_KV_m.mp4"), t.b),
                    a = new URL(t("./src/assets/images/section2_wet_and_dry.png"), t.b),
                    r = new URL(t("./src/assets/images/section2_wet_and_dry_m.png"), t.b),
                    p = new URL(t("./src/assets/images/section2_JawScrapers.png"), t.b),
                    g = new URL(t("./src/assets/images/section2_JawScrapers_m.png"), t.b),
                    _ = new URL(t("./src/assets/images/section2_complete_clean.png"), t.b),
                    m = new URL(t("./src/assets/images/section2_complete_clean_m.png"), t.b),
                    u = new URL(t("./src/assets/images/section2_drying_roller.png"), t.b),
                    l = new URL(t("./src/assets/images/section2_drying_roller_m.png"), t.b),
                    d = new URL(t("./src/assets/images/section2_SlideTech.png"), t.b),
                    f = new URL(t("./src/assets/images/section2_SlideTech_m.png"), t.b),
                    b = new URL(t("./src/assets/images/section2_intelligent_app.png"), t.b),
                    w = new URL(t("./src/assets/images/section2_intelligent_app_m.png"), t.b),
                    v = new URL(t("./src/assets/images/section3_family.png"), t.b),
                    h = new URL(t("./src/assets/images/section3_family_m.png"), t.b),
                    x = new URL(t("./src/assets/video/section4_video.mp4"), t.b),
                    y = new URL(t("./src/assets/video/section4_video_m.mp4"), t.b),
                    R = new URL(t("./src/assets/video/section6_video_1.mp4"), t.b),
                    j = new URL(t("./src/assets/images/section6_sign1.png"), t.b),
                    F = new URL(t("./src/assets/images/section6_data_icon1.png"), t.b),
                    C = new URL(t("./src/assets/images/section6_data1_line_bg.png"), t.b),
                    L = new URL(t("./src/assets/images/section6_data1_line_bg_m.png"), t.b),
                    U = new URL(t("./src/assets/images/section6_data_icon2.png"), t.b),
                    N = new URL(t("./src/assets/images/section6_data2_line_bg1.png"), t.b),
                    T = new URL(t("./src/assets/images/section6_data_icon3.png"), t.b),
                    S = new URL(t("./src/assets/images/section6_data2_line_bg2.png"), t.b),
                    k = new URL(t("./src/assets/images/section7_sign1.png"), t.b),
                    E = new URL(t("./src/assets/video/section7_video_1.mp4"), t.b),
                    O = new URL(t("./src/assets/images/section7_data_icon1.png"), t.b),
                    A = new URL(t("./src/assets/images/section7_data_icon2.png"), t.b),
                    q = new URL(t("./src/assets/images/section8_bg.png"), t.b),
                    W = new URL(t("./src/assets/images/section8_bg_m.png"), t.b),
                    I = new URL(t("./src/assets/images/section8_sign1.png"), t.b),
                    V = new URL(t("./src/assets/video/section9_video_1.mp4"), t.b),
                    P = new URL(t("./src/assets/images/section10_img1.jpg"), t.b),
                    B = new URL(t("./src/assets/images/section10_img1_m.jpg"), t.b),
                    J = new URL(t("./src/assets/images/section10_icon4.png"), t.b),
                    D = new URL(t("./src/assets/images/section10_icon3.png"), t.b),
                    M = new URL(t("./src/assets/images/section10_icon2.png"), t.b),
                    K = new URL(t("./src/assets/images/section10_icon1.png"), t.b),
                    H = new URL(t("./src/assets/images/section11_img1.png"), t.b),
                    $ = new URL(t("./src/assets/images/section11_img1_m.png"), t.b),
                    z = new URL(t("./src/assets/video/section12_video_1.mp4"), t.b),
                    G = new URL(t("./src/assets/video/section12_video_1_m.mp4"), t.b),
                    Y = new URL(t("./src/assets/video/section13_video_1.mp4"), t.b),
                    Q = new URL(t("./src/assets/video/section13_video_2.mp4"), t.b),
                    X = new URL(t("./src/assets/video/section13_video_3.mp4"), t.b),
                    Z = new URL(t("./src/assets/video/section13_video_4.mp4"), t.b),
                    ee = new URL(t("./src/assets/video/section14_video_1.mp4"), t.b),
                    se = new URL(t("./src/assets/video/section14_video_1_m.mp4"), t.b),
                    te = new URL(t("./src/assets/images/section14_sign1.png"), t.b),
                    ie = new URL(t("./src/assets/images/section14_sign1_m.png"), t.b),
                    ne = new URL(t("./src/assets/images/section15_bg1.png"), t.b),
                    oe = new URL(t("./src/assets/images/section15_bg1_m.png"), t.b),
                    ce = new URL(t("./src/assets/images/section15_bg2.png"), t.b),
                    ae = new URL(t("./src/assets/images/section15_bg2_m.png"), t.b),
                    re = new URL(t("./src/assets/images/section15_custom_icon1.png"), t.b),
                    pe = new URL(t("./src/assets/images/section15_bg3.png"), t.b),
                    ge = new URL(t("./src/assets/images/section15_bg3_m.png"), t.b),
                    _e = new URL(t("./src/assets/images/section15_custom_icon2.png"), t.b),
                    me = new URL(t("./src/assets/images/section_compare_f25rt_RT.png"), t.b),
                    ue = new URL(t("./src/assets/images/section_compare_F25.png"), t.b),
                    le = new URL(t("./src/assets/images/section_compare_f25rt_ACE.png"), t.b),
                    de = new URL(t("./src/assets/images/section15_image_1.jpg"), t.b),
                    fe = new URL(t("./src/assets/images/section15_image_2.jpg"), t.b),
                    be = new URL(t("./src/assets/images/section15_image_3.jpg"), t.b),
                    we = new URL(t("./src/assets/images/section15_image_4.jpg"), t.b),
                    ve = new URL(t("./src/assets/images/section15_image_5.jpg"), t.b),
                    he = new URL(t("./src/assets/images/section15_image_6.jpg"), t.b),
                    xe = new URL(t("./src/assets/images/section15_image_7.jpg"), t.b),
                    ye = new URL(t("./src/assets/images/section15_image_8.jpg"), t.b),
                    Re = new URL(t("./src/assets/images/section15_image_9.jpg"), t.b),
                    je = new URL(t("./src/assets/images/section15_image_10.jpg"), t.b),
                    Fe = new URL(t("./src/assets/images/section15_image_11.jpg"), t.b),
                    Ce = new URL(t("./src/assets/images/section15_image_12.jpg"), t.b),
                    Le = new URL(t("./src/assets/images/section15_image_13.jpg"), t.b),
                    Ue = new URL(t("./src/assets/images/section15_image_14.jpg"), t.b),
                    Ne = new URL(t("./src/assets/images/section15_image_15.jpg"), t.b),
                    Te = new URL(t("./src/assets/images/section15_image_16.jpg"), t.b),
                    Se = new URL(t("./src/assets/images/section15_image_17.jpg"), t.b),
                    ke = new URL(t("./src/assets/images/section15_image_18.jpg"), t.b);
                n()(o), n()(c), n()(a), n()(r), n()(p), n()(g), n()(_), n()(m), n()(u), n()(l), n()(d), n()(f), n()(b), n()(w), n()(v), n()(h), n()(x), n()(y), n()(R), n()(j), n()(F), n()(C), n()(L), n()(U), n()(N), n()(T), n()(S), n()(k), n()(E), n()(O), n()(A), n()(q), n()(W), n()(I), n()(V), n()(P), n()(B), n()(J), n()(D), n()(M), n()(K), n()(H), n()($), n()(z), n()(G), n()(Y), n()(Q), n()(X), n()(Z), n()(ee), n()(se), n()(te), n()(ie), n()(ne), n()(oe), n()(ce), n()(ae), n()(re), n()(pe), n()(ge), n()(_e), n()(me), n()(ue), n()(le), n()(de), n()(fe), n()(be), n()(we), n()(ve), n()(he), n()(xe), n()(ye), n()(Re), n()(je), n()(Fe), n()(Ce), n()(Le), n()(Ue), n()(Ne), n()(Te), n()(Se), n()(ke)
            },
            "./node_modules/html-loader/dist/runtime/getUrl.js": function(e) {
                "use strict";
                e.exports = function(e, s) {
                    return s || (s = {}), e ? (e = String(e.__esModule ? e.default : e), s.hash && (e += s.hash), s.maybeNeedQuotes && /[\t\n\f\r "'=<>`]/.test(e) ? '"'.concat(e, '"') : e) : e
                }
            },
            "./src/assets/images/section10_icon1.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section10_icon1.png"
            },
            "./src/assets/images/section10_icon2.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section10_icon2.png"
            },
            "./src/assets/images/section10_icon3.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section10_icon3.png"
            },
            "./src/assets/images/section10_icon4.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section10_icon4.png"
            },
            "./src/assets/images/section10_img1.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section10_img1.jpg"
            },
            "./src/assets/images/section10_img1_m.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section10_img1_m.jpg"
            },
            "./src/assets/images/section11_img1.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section11_img1.png"
            },
            "./src/assets/images/section11_img1_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section11_img1_m.png"
            },
            "./src/assets/images/section14_sign1.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section14_sign1.png"
            },
            "./src/assets/images/section14_sign1_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section14_sign1_m.png"
            },
            "./src/assets/images/section15_bg1.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_bg1.png"
            },
            "./src/assets/images/section15_bg1_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_bg1_m.png"
            },
            "./src/assets/images/section15_bg2.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_bg2.png"
            },
            "./src/assets/images/section15_bg2_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_bg2_m.png"
            },
            "./src/assets/images/section15_bg3.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_bg3.png"
            },
            "./src/assets/images/section15_bg3_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_bg3_m.png"
            },
            "./src/assets/images/section15_custom_icon1.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_custom_icon1.png"
            },
            "./src/assets/images/section15_custom_icon2.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_custom_icon2.png"
            },
            "./src/assets/images/section15_image_1.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_image_1.jpg"
            },
            "./src/assets/images/section15_image_10.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_image_10.jpg"
            },
            "./src/assets/images/section15_image_11.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_image_11.jpg"
            },
            "./src/assets/images/section15_image_12.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_image_12.jpg"
            },
            "./src/assets/images/section15_image_13.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_image_13.jpg"
            },
            "./src/assets/images/section15_image_14.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_image_14.jpg"
            },
            "./src/assets/images/section15_image_15.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_image_15.jpg"
            },
            "./src/assets/images/section15_image_16.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_image_16.jpg"
            },
            "./src/assets/images/section15_image_17.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_image_17.jpg"
            },
            "./src/assets/images/section15_image_18.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_image_18.jpg"
            },
            "./src/assets/images/section15_image_2.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_image_2.jpg"
            },
            "./src/assets/images/section15_image_3.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_image_3.jpg"
            },
            "./src/assets/images/section15_image_4.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_image_4.jpg"
            },
            "./src/assets/images/section15_image_5.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_image_5.jpg"
            },
            "./src/assets/images/section15_image_6.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_image_6.jpg"
            },
            "./src/assets/images/section15_image_7.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_image_7.jpg"
            },
            "./src/assets/images/section15_image_8.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_image_8.jpg"
            },
            "./src/assets/images/section15_image_9.jpg": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section15_image_9.jpg"
            },
            "./src/assets/images/section2_JawScrapers.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section2_JawScrapers.png"
            },
            "./src/assets/images/section2_JawScrapers_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section2_JawScrapers_m.png"
            },
            "./src/assets/images/section2_SlideTech.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section2_SlideTech.png"
            },
            "./src/assets/images/section2_SlideTech_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section2_SlideTech_m.png"
            },
            "./src/assets/images/section2_complete_clean.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section2_complete_clean.png"
            },
            "./src/assets/images/section2_complete_clean_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section2_complete_clean_m.png"
            },
            "./src/assets/images/section2_drying_roller.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section2_drying_roller.png"
            },
            "./src/assets/images/section2_drying_roller_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section2_drying_roller_m.png"
            },
            "./src/assets/images/section2_intelligent_app.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section2_intelligent_app.png"
            },
            "./src/assets/images/section2_intelligent_app_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section2_intelligent_app_m.png"
            },
            "./src/assets/images/section2_wet_and_dry.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section2_wet_and_dry.png"
            },
            "./src/assets/images/section2_wet_and_dry_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section2_wet_and_dry_m.png"
            },
            "./src/assets/images/section3_family.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section3_family.png"
            },
            "./src/assets/images/section3_family_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section3_family_m.png"
            },
            "./src/assets/images/section6_data1_line_bg.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section6_data1_line_bg.png"
            },
            "./src/assets/images/section6_data1_line_bg_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section6_data1_line_bg_m.png"
            },
            "./src/assets/images/section6_data2_line_bg1.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section6_data2_line_bg1.png"
            },
            "./src/assets/images/section6_data2_line_bg2.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section6_data2_line_bg2.png"
            },
            "./src/assets/images/section6_data_icon1.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section6_data_icon1.png"
            },
            "./src/assets/images/section6_data_icon2.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section6_data_icon2.png"
            },
            "./src/assets/images/section6_data_icon3.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section6_data_icon3.png"
            },
            "./src/assets/images/section6_sign1.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section6_sign1.png"
            },
            "./src/assets/images/section7_data_icon1.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section7_data_icon1.png"
            },
            "./src/assets/images/section7_data_icon2.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section7_data_icon2.png"
            },
            "./src/assets/images/section7_sign1.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section7_sign1.png"
            },
            "./src/assets/images/section8_bg.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section8_bg.png"
            },
            "./src/assets/images/section8_bg_m.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section8_bg_m.png"
            },
            "./src/assets/images/section8_sign1.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section8_sign1.png"
            },
            "./src/assets/images/section_compare_F25.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section_compare_F25.png"
            },
            "./src/assets/images/section_compare_f25rt_ACE.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section_compare_f25rt_ACE.png"
            },
            "./src/assets/images/section_compare_f25rt_RT.png": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section_compare_f25rt_RT.png"
            },
            "./src/assets/video/section12_video_1.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section12_video_1.mp4"
            },
            "./src/assets/video/section12_video_1_m.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section12_video_1_m.mp4"
            },
            "./src/assets/video/section13_video_1.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section13_video_1.mp4"
            },
            "./src/assets/video/section13_video_2.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section13_video_2.mp4"
            },
            "./src/assets/video/section13_video_3.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section13_video_3.mp4"
            },
            "./src/assets/video/section13_video_4.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section13_video_4.mp4"
            },
            "./src/assets/video/section14_video_1.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section14_video_1.mp4"
            },
            "./src/assets/video/section14_video_1_m.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section14_video_1_m.mp4"
            },
            "./src/assets/video/section1_KV.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section1_KV.mp4"
            },
            "./src/assets/video/section1_KV_m.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section1_KV_m.mp4"
            },
            "./src/assets/video/section4_video.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section4_video.mp4"
            },
            "./src/assets/video/section4_video_m.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section4_video_m.mp4"
            },
            "./src/assets/video/section6_video_1.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section6_video_1.mp4"
            },
            "./src/assets/video/section7_video_1.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section7_video_1.mp4"
            },
            "./src/assets/video/section9_video_1.mp4": function(e, s, t) {
                "use strict";
                e.exports = t.p + "files/f25rt_section9_video_1.mp4"
            },
            jquery: function(e) {
                "use strict";
                e.exports = $
            }
        },
        s = {};

    function t(i) {
        var n = s[i];
        if (void 0 !== n) return n.exports;
        var o = s[i] = {
            exports: {}
        };
        return e[i](o, o.exports, t), o.exports
    }
    t.m = e, t.n = function(e) {
            var s = e && e.__esModule ? function() {
                return e.default
            } : function() {
                return e
            };
            return t.d(s, {
                a: s
            }), s
        }, t.d = function(e, s) {
            for (var i in s) t.o(s, i) && !t.o(e, i) && Object.defineProperty(e, i, {
                enumerable: !0,
                get: s[i]
            })
        }, t.o = function(e, s) {
            return Object.prototype.hasOwnProperty.call(e, s)
        }, t.p = "/cdn/shop/", t.b = document.baseURI || self.location.href,
        function() {
            "use strict";
            t("./src/index.html"), t("./src/widgets/index.js"), t("./src/js/main.js")
        }()
}();